// src/components/services/Services.js
import React from "react";
import "./Styles.css";

const servicesList = [
  {
    title: "Formatação Completa",
    description: "Seu PC limpo, rápido e livre de vírus. Sem perder arquivos importantes.",
    price: "R$150,00"
  },
  {
    title: "Upgrade de Hardware",
    description: "SSD, memória RAM e placas de vídeo para mais velocidade e desempenho.",
    price: "R$200,00"
  },
  {
    title: "Suporte Técnico",
    description: "Resolvemos travamentos, lentidão e problemas de software rapidamente.",
    price: "R$120,00"
  },
  {
    title: "Conserto de Hardware",
    description: "Substituição de peças, reparo e manutenção especializada.",
    price: "R$180,00"
  }
];

export default function Services() {
  return (
    <section className="services-section">
      <h2>Nossos Serviços</h2>
      <div className="services">
        {servicesList.map((service, index) => (
          <div className="service-card" key={index}>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <div className="price">{service.price}</div>
          </div>
        ))}
      </div>
      <a
        href="https://wa.me/5515996879862?text=Ol%C3%A1!%20Vi%20sua%20landing%20page%20e%20quero%20agendar%20um%20servi%C3%A7o%20de%20manuten%C3%A7%C3%A3o."

        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-action"
      >
        <i className="fab fa-whatsapp"></i> Fale conosco
      </a>
    </section>
  );
}
